import axios from 'axios'
import jsonpAjax from './jsonpAjax.js'
import { showToast } from 'vant'
import { toLogin } from '@/utils'

// axios函数封装
const ajax = async ({
  url = '',
  loading = false, // 加载拦截
  baseURL = '',
  data = {},
  headers = { 'Content-Type': 'application/json;charset=UTF-8' }, // 头部信息处理
  method = 'get',
  timeout = 30 * 1000,
  responseType = 'json', // 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
  jsonp = false, //是否使用jsonp请求接口
  jsonpOpt = {}, // jsonp库的options参数
  signal = null, // 添加signal参数支持AbortController
}) => {
  // 接口全局加载提示
  let loadingInstance = ''
  if (loading !== false) {
    loadingInstance = showToast.loading({
      duration: 0,
      forbidClick: true,
      message: loading !== true ? loading : '加载中……',
    })
  }
  try {
    const posts = ['put', 'post', 'patch'] // 使用data作为发送数据主体
    let response = null
    if (jsonp) {
      response = await jsonpAjax({
        url,
        baseURL,
        data,
        timeout,
        jsonpOpt,
      })
    } else {
      response = await axios({
        url: url,
        baseURL: baseURL,
        headers: headers,
        method: method,
        [posts.includes(method.toLowerCase()) ? 'data' : 'params']: data,
        timeout: timeout,
        responseType,
        signal, // 添加signal支持
      })
    }

    loadingInstance && loadingInstance.clear()
    return Promise.resolve(response)
  } catch (e) {
    loadingInstance && loadingInstance.clear()
    if (e.errorCode === '30010') {
      // toLogin()
    }
    return Promise.reject(e)
  }
}

export { ajax }
